import styled from 'styled-components';
import { ITheme } from '../../styles/theme';

interface ITableTileCont {
  theme: ITheme;
  isShadowed: boolean;
}

export const TableTileCont = styled.div<ITableTileCont>`
  display: flex;
  flex-direction: column;
  min-height: 60px;
  box-sizing: border-box;
  position: relative;
  justify-content: center;
  ${({ isShadowed, theme }: ITableTileCont) => `
    box-shadow: ${isShadowed ? `0px 1px 1px ${theme.colors.neutral.primary[40]}` : null};
    background: ${theme.colors.neutral.primary[0]};
    border-radius: 8px;
    margin: 0 0 10px 0;
  `};
`;
